import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { avoid } from './shared/avoid'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { productName } from './shared/productName'
import { productFeatures } from './shared/productFeatures'
import { Faq } from 'almanac-ui/icons/blaze/32'
import { count } from './shared/count'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.FAQs,
  icon: Faq,
  steps: ['Context', 'Generate FAQs'],
  title: TextChannels[ChannelType.FAQs].name,
  submitLabel: 'Generate FAQs',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183787/Home%20Card%20Previews/f0jqg31hrp6l2ra4tcv5.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your FAQ?', generationType: meta.type }),
  product_name: productName.required(),
  product_features: productFeatures.meta({ inCollapsibleSection: true }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  tone,
  count: count.default(6).min(1).max(20).meta({ label: 'How many questions do you want to generate?' }),
  include_images: includeImages,
  language,
  avoid: avoid.meta({ collapsible: true }),
  source_material_ids: sourceMaterialIds,
}

export const FAQSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const FAQsMultiStepSchema: MultiStepSchema<ChannelType.FAQs> = {
  steps: [
    FAQSchema.omit(['include_images']).meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.FAQs,
    channel: ChannelType.FAQs,
  },
}
